module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-ko-KR.0c9d5cc1.jpg";